export default __webpack_public_path__ + "/dist/images/logo1.e43435845677dcf933dc5b97798fc136.png";